import servicesProvider from "../services/ServicesProvider";
import { db } from "../script/Fetch";
import Notifier from "../repositories/Notifier";

export default class NotifierService {
    createStoricoClientiNotifier(ristoranteId: string, callback: any): Notifier {
        let returnValue = new Notifier(
            db.collection("clienti")
                .where("idRistorante", "==", ristoranteId),
            servicesProvider.getClienteDbQueries().convertFromFirestore,
            callback
        );
        return returnValue;
    }

    createClientiConnessiNotifier(ristoranteId: string, callbackClientiConnessi: any, callbackOrdiniClientiConnessi: any): Notifier {
        let returnValue = new Notifier(
            db.collection("clienti")
                .where("idRistorante", "==", ristoranteId)
                .where("connesso", "not-in", [2]),
            servicesProvider.getClienteDbQueries().convertFromFirestore,
            (clientiById) => {
                let ordiniByClienteId: any = {};
                Object.keys(clientiById).forEach(clienteId => {
                    servicesProvider.getNotifierService().createOrdiniClienteNotifier(clienteId, (value: any) => {
                        ordiniByClienteId[clienteId] = value;
                        callbackOrdiniClientiConnessi(ordiniByClienteId);
                    });
                });
                callbackClientiConnessi(clientiById);
            }
        );
        return returnValue;
    }

    createOrdiniClienteNotifier(clienteId: string, callback: any): Notifier {
        let returnValue = new Notifier(
            db.collection("clienti")
                .doc(clienteId)
                .collection("ordini"),
            servicesProvider.getOrdineDbQueries().convertFromFirestore,
            callback
        );
        return returnValue;
    }
}